import {Component, ElementRef, inject, Input, OnInit, ViewChild} from '@angular/core';
import {ApiResponse, sdgActive, sdgInactive, sdgs} from "../../services/utils";
import {PostModel, ProductModel} from "../../models/post.model";
import {NavigationService} from "../../services/navigations/navigation.service";
import {CompanyModel} from "../../models/company.model";
import {GlobalService} from "../../services/global/global.service";
import {UserModel} from "../../models/user.model";
import {AuthService} from "../../services/auth/auth.service";
import {ActionPointService} from "../../services/action-points/action-point.service";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Capacitor} from "@capacitor/core";
import {NativeAudio} from "@capgo/native-audio";
import {PostService} from "../../services/post/post.service";
import {StorageService} from "../../services/storage/storage.service";
import {CommentsComponent} from "../../components/comments/comments.component";
import {TranslateService} from "@ngx-translate/core";
import {ModalController, NavController, PopoverController} from "@ionic/angular";
import {ShareService} from "../../services/share/share.service";
import {SetMetaService} from "../../services/set-meta/set-meta.service";
import {TagUserComponent} from "../../components/tag-user/tag-user.component";
import Swiper from "swiper";
import {SetRatingComponent} from "../../components/set-rating/set-rating.component";
import {GalleryModalComponent} from "../gallery-modal/gallery-modal.component";


@Component({
  selector: 'app-action-point-detail-modal',
  templateUrl: './action-point-detail-modal.component.html',
  styleUrls: ['./action-point-detail-modal.component.scss'],
  standalone: false
})
export class ActionPointDetailModalComponent implements OnInit {
  @Input() item: PostModel;
  @Input() actionPointId: string;
  @Input() page: string;
  @ViewChild(CommentsComponent) commentsComponent: CommentsComponent;
  @ViewChild('commentInputElement') commentInput: ElementRef<HTMLTextAreaElement>;
  @ViewChild(TagUserComponent) tagUserComponent: TagUserComponent;
  @ViewChild('swiperContainer', {static: false}) swiperContainer: ElementRef;

  public commentForm: UntypedFormGroup;

  public isBrowser: boolean = true;
  public translateFlag: boolean = false;
  public adoptPost: boolean = true;
  public swiperInitialized: boolean = false;
  public loadingComplete: boolean = false;
  public showCommentBox: boolean = false;
  public likeButtonDisabled: boolean = false;
  public galleryIsOpen: boolean = false;
  public hasMoreMoments: boolean = true;
  public loadingMoments: boolean = false;
  public reasonNotAdoptOwn: boolean = true;
  public tagSelectedFlag: boolean = false;

  public createdTime: string;
  public postType: string = 'action_point';
  public commentScrollBottom: string = 'no';
  public colorOfEarth: string;

  public findIndex: number = 0;
  public totalUsersRatedCount: number;
  public momentPagination: number = 1;

  public user: UserModel;
  public products: ProductModel[];
  public moments: PostModel[] = [];
  public userSelectedTags: UserModel[] = [];

  public swiper: Swiper;

  protected readonly sdgInactiveArray = sdgInactive;
  protected readonly sdgActiveArray = sdgActive;

  public modalElement: any;
  public sdgs2: any[] = [];
  public errorMessage: any[] = [];


  private navigationService: NavigationService = inject(NavigationService);
  private actionPointService: ActionPointService = inject(ActionPointService);
  private auth: AuthService = inject(AuthService);
  private globalService: GlobalService = inject(GlobalService);
  private postService: PostService = inject(PostService);
  private storage: StorageService = inject(StorageService);
  private translate: TranslateService = inject(TranslateService);
  private popoverCtrl: PopoverController = inject(PopoverController);
  private shareService: ShareService = inject(ShareService);
  private setMeta: SetMetaService = inject(SetMetaService);
  private modalController: ModalController = inject(ModalController);
  private navController: NavController = inject(NavController);

  constructor() {
    this.sdgs2 = sdgs;
    this.sdgs2.forEach(sdg => {
      sdg.checked = false;
    });
    this.commentForm = new UntypedFormGroup({
      comment: new UntypedFormControl(
        '', Validators.required
      ),
      commentId: new UntypedFormControl(
        '', null
      ),
    });
  }

  public resize(): void {
    this.tagSelectedFlag = false;
    this.commentInput.nativeElement.style.height = 'auto';
    this.commentInput.nativeElement.style.height = this.commentInput.nativeElement.scrollHeight + 'px';
  }

  public ngOnInit(): void {
    this.isBrowser = this.globalService.isBrowser;
    this.createdTime = this.globalService.timeSince(this.item?.createdAt);

    if (this.isBrowser) {
      this.user = this.auth.user;
      this.auth.getUserStatus.subscribe(() => {
        this.user = this.auth.user;
      });
    }

    this.loadActionPoint(this.actionPointId);
  }

  public ngAfterViewInit(): void {
    this.commentForm.get('comment').valueChanges.subscribe((val: any) => {
      if (val?.lastIndexOf('@') !== -1 && val?.lastIndexOf('@') > val?.lastIndexOf(' ') && this.tagSelectedFlag === false) {
        this.findIndex = val.lastIndexOf('@');
        const newVal = val.substring(this.findIndex + 1, val.length);
        this.tagUserComponent.getItems(newVal);

      }
      if (val?.lastIndexOf('@') === -1) {
        this.tagUserComponent.getItems('');
      }
    });

    this.tryInitializeSwiper();
  }

  async ngAfterViewChecked(): Promise<void> {
    if (!this.swiperInitialized) {
      this.tryInitializeSwiper();
    }
  }


  public openCompanyProfile(company: CompanyModel): void {
    this.modalController.dismiss();
    this.navigationService.openCompanyProfile(company);
  }

  public openOtherProfile(id): void {
    this.modalController.dismiss();
    this.navigationService.openOtherUserProfile(id, this.item.createdBy.isDeleted);
  }

  public async editPost(item): Promise<void> {
    await this.actionPointService.editPost(item);
  }

  public reportPost(item): void {
    this.actionPointService.reportPost(item);
  }

  public hidePost(item): void {
    this.actionPointService.hidePost(item);
  }

  public blockUser(item): void {
    this.actionPointService.blockUser(item);
  }

  public async deletePost(item): Promise<void> {
    await this.actionPointService.deletePost(item);
  }

  public isAnonymousAction(): void {
    this.modalController.dismiss();
    if (!(this.user && this.auth.isAuthenticated)) {
      this.globalService.openLoginModal();
    }
  }

  public checkIsString(txt: string): boolean {
    return typeof txt === 'string';
  }

  public writeDescriptionToClipboard(text: string): void {
    this.globalService.writeToClipboard(text);
  }

  public translatePost(item): void {
    this.translateFlag = !this.translateFlag;

    this.actionPointService.translatePost(item).subscribe((data) => {
      this.item = data;
    });
  }

  async openInteraction(item, type): Promise<void> {
    await this.modalController.dismiss();
    await this.navigationService.openInteraction(item, type);
  }

  public openLink(url): void {
    this.modalController.dismiss();
    window.open(url, '_system');
  }

  // check logic
  public listPost(item): void {
    if (this.auth && this.auth.isAuthenticated) {
      this.likeButtonDisabled = true;
      const data = {postId: item?.id};

      this.postService.apiLikeActionPoint(data).subscribe(async (result: ApiResponse) => {
        if (result.status) {
          this.item = result.data;
          this.postService.postEvent.next(this.item);
          if (result.data.isLiked && Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
            NativeAudio.play({
              assetId: 'like',
              time: 0
            });
          }
        }
        this.likeButtonDisabled = false;
      });
    } else {
      this.isAnonymousAction();
    }
  }

  public getContent(item: any): any[] {
    let str = item.description;
    const arrToReturn = [];
    let counter = 0;

    item.userTag.forEach((element, index) => {
      const q = '@' + element.username;
      if (str.indexOf(q) !== -1) {
        const startIndex = str.indexOf(q);
        const endIndex = startIndex + q.length;
        if (str.indexOf(q) === 0) {
          arrToReturn.push(counter);
          str = str.substring(endIndex, str.length);
        } else {
          arrToReturn.push(str.substring(0, startIndex));
          arrToReturn.push(counter);
          str = str.substring(endIndex, str.length);
        }
      }
      if (str.length > 0 && index + 1 === item.userTag.length) {
        arrToReturn.push(str);
      }
      counter++;
    });

    if (counter !== 0 && arrToReturn.length !== 0) {
      return arrToReturn;
    } else {
      arrToReturn.push(str);
      return arrToReturn;
    }
  }

  public setRating(event: any): void {
    this.setColorOfRatingButton(event.item.star);
    if (event.popupClose) {
      this.item.isRated = event.item.isRated;
      this.item.star = event.item.star;
    }
    this.popoverCtrl.dismiss({
      rating: {
        item: this.item
      }
    }, 'confirm');
  }

  public setColorOfRatingButton(starsAvg): void {
    this.colorOfEarth = this.postService.setRatingColor(starsAvg, this.totalUsersRatedCount);
  }

  public addAdoptActionPoint(item): void {
    if (this.user && this.auth.isAuthenticated) {
      const data = {postId: item?.id};
      if (!item?.isAdopted) {
        this.postService.apiAddAdoptActionPoint(data).subscribe(async (result: ApiResponse) => {
          if (result.status) {
            this.loadActionPoint(item.id);
            if (Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
              NativeAudio.play({
                assetId: 'adopt',
                time: 0
              });
            }
            if (this.item.company && this.item?.action_point_type === 'company') {
              await this.globalService.presentToast(this.translate.instant('txt_ap_adopted_from_company'), 4000);
            } else {
              await this.globalService.presentToast(this.translate.instant('txt_ap_adopted'));
            }
          } else {
            await this.globalService.presentToast(this.translate.instant('err_general'));
          }
        });
      } else {
        this.postService.apiRemoveAdoptAP(data).subscribe(async (result: ApiResponse) => {
          if (result.status) {
            this.loadActionPoint(item.id);
            await this.globalService.presentToast(this.translate.instant('txt_ap_unadopted'));
          } else {
            await this.globalService.presentToast(this.translate.instant('err_general'));
          }
        });
      }
    } else {
      this.isAnonymousAction();
    }
  }

  public commentSubmit(): void {
    if (!this.commentForm.valid) {
      this.commentForm.markAllAsTouched();
      return;
    }
    const userTags = [];
    this.userSelectedTags.forEach(element => {
      if (this.commentForm.value.comment.includes('@' + element.username)) {
        userTags.push(element.id);
      }
    });
    // this.commentsComponent.commentSubmit(this.commentForm, userTags);
    this.item.commentsCount += 1;
    this.globalService.presentToast(this.translate.instant('txt_comment_got_posted'));
  }

  public cannotAdoptActionPoint(): void {
    if (this.reasonNotAdoptOwn) {
      this.globalService.presentToast(this.translate.instant('txt_cannot_adopt_your_own'));
    }
  }

  public async sharePost(item: any): Promise<void> {
    const filepath = item && item.media && item.media[0] && item.media[0].path ? item.media[0].path : '';
    await this.shareService.share(item.id, item.title, item.description, item.shareUrl, filepath);
  }

  public loadActionPoint(postId: string): void {
    this.actionPointService.loadActionPointData(postId, this.sdgs2).subscribe({
      next: (data) => {
        this.item = data.item;
        this.products = data.products;
        this.createdTime = data.createdTime;
        this.totalUsersRatedCount = data.totalUsersRatedCount;
        this.sdgs2 = data.sdgsUpdated;

        this.setMeta.setMetaData(this.item.title, this.item.description, data.image);
        this.commentsComponent?.loadCommentByComponent();
        this.setColorOfRatingButton(this.item.star);

        this.loadMoments();
        this.viewAdopt();
      },
      error: (err) => {
        this.errorMessage = err;
        this.viewAdopt();
      }
    });
  }

  public loadMoments(): Promise<void> {
    return new Promise((resolve) => {
      if (this.loadingMoments || !this.hasMoreMoments) {
        resolve();
        return;
      }

      this.loadingMoments = true;

      this.postService.apiGetActionPointMoments(this.item.id.toString(), this.momentPagination).subscribe((result: ApiResponse) => {
        this.loadingMoments = false;

        if (result.status && Array.isArray(result.data.data)) {
          const newMoments = result.data.data;
          const pagination = result.data.pagination;


          if (newMoments.length > 0) {
            this.moments = [...this.moments, ...newMoments];

            if (pagination.nextPageUrl) {
              this.momentPagination++;
            } else {
              this.hasMoreMoments = false;
            }
          } else {
            this.hasMoreMoments = false;
          }
        } else {
          this.hasMoreMoments = false;
        }
        resolve();
      });
    });
  }

  public viewAdopt(): void {
    if (this.user && this.user.id === this.item?.createdBy?.id) {
      this.adoptPost = false;
      this.reasonNotAdoptOwn = true;
    } else if (this.user && this.user.id !== this.item?.createdBy?.id) {
      this.adoptPost = true;
    }
  }

  public selectedUser(event): void {
    this.userSelectedTags.push(event.user);
    this.tagSelectedFlag = true;
    const str = this.commentForm.get('comment').value;
    this.commentForm.get('comment').setValue(str.substring(0, this.findIndex) + '@' + event.user.username + ' ');
    setTimeout(() => {
      const val = this.commentInput.nativeElement.value.length;
      this.commentInput.nativeElement.setSelectionRange(val, val);
      this.commentInput.nativeElement.focus();
    }, 50);
  }

  public setCommentBoxValue(event): void {
    this.commentForm.setValue(event.val);
  }

  public async focusToCommentBar(): Promise<void> {
    this.showCommentBox = !this.showCommentBox;

    if (this.user && this.user.id) {
      setTimeout(() => {
        if (this.showCommentBox) {
          this.commentInput.nativeElement.focus();
        }
      }, 100);

      const modal = await this.modalController.getTop();
      if (modal && modal.setCurrentBreakpoint) {
        modal.setCurrentBreakpoint(this.showCommentBox ? 0.8 : 0.7);
      }
    } else {
      this.isAnonymousAction();
    }
  }

  public loadMoreComments(event): void {
    if (this.item && this.item.commentsCount > 3) {
      this.commentsComponent.loadMoreComments(event);
    } else {
      event.target.complete();
      this.loadingComplete = true;
    }
  }

  public async openActionPoint(item: PostModel): Promise<void> {
    await this.navController.navigateForward(['/app/home/view-post/' + item.type + '/' + item?.id + '/detail']);
    await this.modalController.dismiss();
    await this.modalController.dismiss();
  }

  public async openActionPointComment(item): Promise<void> {
    await this.navController.navigateForward([
      '/app/home/view-post', item.type, item?.id, 'detail'
    ], {
      queryParams: {
        comment: true
      }
    });
    await this.modalController.dismiss();
    await this.modalController.dismiss();
  }

  // swiper
  public initSwiperFunc(): void {
    this.swiper = new Swiper(this.swiperContainer.nativeElement, {
      loop: false,
      autoplay: true,
      slidesPerView: 6,
      slidesPerGroup: 6,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });
    if (this.swiper) {
      this.swiper.init();
    }
  }

  public tryInitializeSwiper(): void {
    if (this.swiperContainer && this.isElementVisible(this.swiperContainer.nativeElement)) {
      this.initSwiperFunc();
      this.swiperInitialized = true;
    }
  }

  public isElementVisible(element: HTMLElement): boolean {
    if (this.globalService.isBrowser) {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    } else {
      return false;
    }
  }

  public async openRatingPopover(event: Event, item: any): Promise<void> {
    event.stopPropagation();

    const popover = await this.popoverCtrl.create({
      component: SetRatingComponent,
      componentProps: {item},
      event,
      translucent: true,
      cssClass: 'rating-popover',
      showBackdrop: true,
      backdropDismiss: true,
      side: 'top',
      mode: 'md'
    });

    popover.onWillDismiss().then((data) => {
      if (data?.role === 'confirm') {

        const updatedItem = data?.data?.rating?.item;
        if (updatedItem) {
          this.item = updatedItem;
          this.setColorOfRatingButton(updatedItem.star);
        }
      }
    });

    await popover.present();
  }

  public async openGallery(actionPointId: number, momentId: number): Promise<void> {
    this.modalElement = await this.modalController.create({
      component: GalleryModalComponent,
      backdropDismiss: true,
      mode: 'ios',
      id: 'inline-modal',
      cssClass: 'modal-gallery',
      componentProps: {
        momentId: momentId,
        actionPointId: actionPointId,
        actionPointFeed: true
      }
    })
    await this.modalElement.present();
    this.galleryIsOpen = true;
  }

  public handleInfinite(event: any): void {
    this.loadMoments().then(() => {
      event.target.complete();
    });
  }

}
